// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/company_status.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file inventory/v1/company_status.proto.
 */
export const file_inventory_v1_company_status: GenFile = /*@__PURE__*/
  fileDesc("CiFpbnZlbnRvcnkvdjEvY29tcGFueV9zdGF0dXMucHJvdG8SDGludmVudG9yeS52MSqzAQoNQ29tcGFueVN0YXR1cxIeChpDT01QQU5ZX1NUQVRVU19VTlNQRUNJRklFRBAAEiYKIkNPTVBBTllfU1RBVFVTX0FTU0VTU01FTlRfUkVRVUlSRUQQARIgChxDT01QQU5ZX1NUQVRVU19JTl9BU1NFU1NNRU5UEAISGwoXQ09NUEFOWV9TVEFUVVNfQVBQUk9WRUQQAxIbChdDT01QQU5ZX1NUQVRVU19SRUpFQ1RFRBAEQroBChBjb20uaW52ZW50b3J5LnYxQhJDb21wYW55U3RhdHVzUHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM");

/**
 * @generated from enum inventory.v1.CompanyStatus
 */
export enum CompanyStatus {
  /**
   * @generated from enum value: COMPANY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMPANY_STATUS_ASSESSMENT_REQUIRED = 1;
   */
  ASSESSMENT_REQUIRED = 1,

  /**
   * @generated from enum value: COMPANY_STATUS_IN_ASSESSMENT = 2;
   */
  IN_ASSESSMENT = 2,

  /**
   * @generated from enum value: COMPANY_STATUS_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: COMPANY_STATUS_REJECTED = 4;
   */
  REJECTED = 4,
}

/**
 * Describes the enum inventory.v1.CompanyStatus.
 */
export const CompanyStatusSchema: GenEnum<CompanyStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_status, 0);

